import tippy from 'tippy.js';

document.addEventListener('DOMContentLoaded', () => {
  tippy('.tooltip__icon', {
    content(reference) {
      const tooltipContent = reference.closest('.tooltip').querySelector('.tooltip__content');
      return tooltipContent.innerHTML;
    },
    allowHTML: true,
    theme: 'custom',
  });
});
